export function validatePlaca(placa?: string): boolean {
  if (!placa) return false;

  const limpa = placa.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  const regexPlacaBR = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/i;

  return regexPlacaBR.test(limpa);
}
